import React, { createContext, useCallback, useContext, useState } from "react";

const ConsultationContext = createContext({ open: () => {}, close: () => {}, isOpen: false, defaultService: "other" });

export function ConsultationProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultService, setDefaultService] = useState("other");

  const open = useCallback((service = "other") => {
    setDefaultService(service);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => setIsOpen(false), []);

  return (
    <ConsultationContext.Provider value={{ isOpen, open, close, defaultService }}>
      {children}
    </ConsultationContext.Provider>
  );
}

export function useConsultation() {
  return useContext(ConsultationContext);
}
